import { SurveyV2 } from '@act/shared/data-transfer-objects';

/**
 * Returns the best available survey name without assuming its relation exists.
 *
 * @param survey - Survey definition, which can be absent for orphaned assignments.
 * @returns Display name, internal name, or a generic survey fallback.
 */
export function getSurveyDisplayName(
  survey: SurveyV2.SurveyDto | null | undefined
): string {
  return survey?.displayName || survey?.name || 'Survey';
}
